<app-form-manager
  formPlugin="core-mapping-spreadsheet-form"
  [params]="params"
  (canceled)="cancel($event)"
  (saveSucceed)="saveSucceed($event)"
  (formEvent)="formEventExecuted($event)"
  #form>
</app-form-manager>
